// Specialized form field for URL inputs
import React from 'react';
import { FormField } from './FormField';
import { TextInputProps } from 'react-native';

interface UrlFormFieldProps extends Omit<TextInputProps, 'keyboardType' | 'autoCapitalize'> {
  label: string;
  error?: string;
  required?: boolean;
  helpText?: string;
}

export const UrlFormField: React.FC<UrlFormFieldProps> = (props) => {
  return (
    <FormField
      {...props}
      keyboardType="url"
      autoCapitalize="none"
    />
  );
};

